import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authAPI } from '../services/api';

export interface Role {
  id: string;
  name: string;
  permissions: string[];
}

export interface User {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role?: Role;
}

interface AuthState {
  user: User | null;
  token: string | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (first_name: string, last_name: string, email: string, password: string) => Promise<void>;
  logout: () => void;
  setLoading: (loading: boolean) => void;
  initializeAuth: () => void;
  hasPermission: (permission: string) => boolean;
  refreshUser: () => Promise<void>;
}



export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      loading: true,

      login: async (email: string, password: string) => {
        try {
          const response = await authAPI.login({ email, password });
          const { token: newToken, user: userData } = response.data.data;
          
          set({ token: newToken, user: userData });
        } catch (error) {
          throw error;
        }
      },

      register: async (first_name: string, last_name: string, email: string, password: string) => {
        try {
          const response = await authAPI.register({ first_name, last_name, email, password });
          const { token: newToken, user: userData } = response.data.data;
          
          set({ token: newToken, user: userData });
        } catch (error) {
          throw error;
        }
      },

      logout: () => {
        set({ token: null, user: null });
      },

      setLoading: (loading: boolean) => {
        set({ loading });
      },

      initializeAuth: () => {
        set({ loading: false });
      },

      hasPermission: (permission: string) => {
        const { user } = get();
        if (!user || !user.role || !user.role.permissions) {
          return false;
        }
        return user.role.permissions.includes(permission);
      },

      refreshUser: async () => {
        try {
          const response = await authAPI.getProfile();
          const userData = response.data.data.user;
          console.log('Refreshed user data:', userData);
          set({ user: userData });
        } catch (error) {
          console.error('Failed to refresh user:', error);
        }
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
      }),
    }
  )
);
